import React,  { useState, useEffect } from 'react';
import { Alert  } from '@mui/material';
import { Grid } from "tabler-react";
import { Crud_Catalogos } from '../herramientas/Crud_Catalogos';
import ModalLayout from './ModalLayout.react';
import ListarAlertasPorCategorias from './ListarAlertasPorCategorias';
import AlertasMensajeria from '../socket/AlertasMensajeria';

var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
var perfil = JSON.parse(sessionStorage.getItem("perfil"));

export const AlertasUnidades = () => {
  //console.log(currentUser[0].usuario.id);

  const [ alertasCategoriasNavieras, setAlertasCategoriasNavieras ] = useState([]);
  const [ alertasCategoriasTerrestres, setAlertasCategoriasTerrestres ] = useState([]);
  const [ alertasCategoriasNavierasPrioritarias, setAlertasCategoriasNavierasPrioritarias ] = useState([]);
  const [ alertasCategoriasTerrestresPrioritarias, setAlertasCategoriasTerrestresPrioritarias ] = useState([]);
  const [ conteoAlertasAtendidasPrioritarias, setConteoAlertasAtendidasPrioritarias] = useState([]);
  const [ conteoAlertasNoAtendidasPrioritarias, setConteoAlertasNoAtendidasPrioritarias] = useState([]);
  const [ conteoAlertasAtendidas, setConteoAlertasAtendidas] = useState([]);
  const [ conteoAlertasNoAtendidas, setConteoAlertasNoAtendidas] = useState([]);
  const [ conteoAlertasAtendidasTerrestresPrioritarias, setConteoAlertasAtendidasTerrestresPrioritarias] = useState([]);
  const [ conteoAlertasNoAtendidasTerrestresPrioritarias, setConteoAlertasNoAtendidasTerrestresPrioritarias] = useState([]);
  const [ conteoAlertasAtendidasTerrestres, setConteoAlertasAtendidasTerrestres] = useState([]);
  const [ conteoAlertasNoAtendidasTerrestres, setConteoAlertasNoAtendidasTerrestres] = useState([]);
  const [ funcionalidades, setFuncionalidades] = useState([]);
  const [ topics, setTopics] = useState([]);

  useEffect(() => {
    let topicsTemp = [];  
    for(let p of currentUser){      
      topicsTemp.push("/topic/alertasEnRuta-" + p.plataforma.id );         
    }    
    setTopics(topicsTemp);  
    crud("get", "", "", "funcionalidades/Modulo_de_Alertas/"+ perfil.id, "funcionalidades");   
  }, []);

  useEffect(() => {    
   if(funcionalidades.filter(f => f.nombre === "Alertas_en_ruta" ).length ){
    //crud("get", "", "", "alertasCategorias/navierasusuario/" + currentUser[0].usuario.id, "alertasCategoriasNavieras");
    //crud("get", "", "", "alertasCategorias/terrestresusuario/" + currentUser[0].usuario.id, "alertasCategoriasTerrestres");
    crud("get", "", "", "alertasCategorias/navieras/" + currentUser[0].usuario.id, "alertasCategoriasNavieras");
    crud("get", "", "", "alertasCategorias/terrestres/" + currentUser[0].usuario.id, "alertasCategoriasTerrestres");
    crud("get", "", "", "alertasCategorias/navierasPrioritarias/" + currentUser[0].usuario.id, "alertasCategoriasNavierasPrioritarias");
    crud("get", "", "", "alertasCategorias/terrestresPrioritarias/" + currentUser[0].usuario.id, "alertasCategoriasTerrestresPrioritarias");
   }
  }, [funcionalidades]);

  const crud = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {    
    return Crud_Catalogos(catalogo, "", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
        switch (metodo) {
            case "get": 
            if(stateVar === "funcionalidades" && returnVal){
              setFuncionalidades(returnVal);
            }
            if(stateVar === "alertasCategoriasNavierasPrioritarias" && returnVal) {
              let alertasCategoriasPrioritariasTemp = [];
              returnVal.map((i, index) => alertasCategoriasPrioritariasTemp.push({value:i.id_alerta_categoria, label:i.nombre, data:i}));
              //console.log(returnVal);
              setAlertasCategoriasNavierasPrioritarias(alertasCategoriasPrioritariasTemp);
              crud("get", "", "", "alertas/atendidasNavierasPrioritarias/" + currentUser[0].usuario.id, "alertasAtendiadasNavierasPrioritarias");
              crud("get", "", "", "alertas/noAtendidasNavierasPrioritarias/" + currentUser[0].usuario.id, "alertasNoAtendiadasNavierasPrioritarias");
            }
            if(stateVar === "alertasCategoriasNavieras" && returnVal) {
              let alertasCategoriasTemp = [];
              returnVal.map((i, index) => alertasCategoriasTemp.push({value:i.id_alerta_categoria, label:i.nombre, data:i}));
              //console.log(returnVal);
              setAlertasCategoriasNavieras(alertasCategoriasTemp);
              crud("get", "", "", "alertas/atendidasNavieras/" + currentUser[0].usuario.id, "alertasAtendiadasNavieras");
              crud("get", "", "", "alertas/noAtendidasNavieras/" + currentUser[0].usuario.id, "alertasNoAtendiadasNavieras");
            }
            if(stateVar === "alertasCategoriasTerrestresPrioritarias" && returnVal) {
              let alertasCategoriasPrioritariasTemp = [];
              returnVal.map((i, index) => alertasCategoriasPrioritariasTemp.push({value:i.id_alerta_categoria, label:i.nombre, data:i}));
              //console.log(returnVal);           
              setAlertasCategoriasTerrestresPrioritarias(alertasCategoriasPrioritariasTemp); 
              crud("get", "", "", "terrestresAlertas/atendidasPrioritarias/" + currentUser[0].usuario.id, "alertasAtendiadasTerrestresPrioritarias");
              crud("get", "", "", "terrestresAlertas/noAtendidasPrioritarias/" + currentUser[0].usuario.id, "alertasNoAtendiadasTerrestresPrioritarias");            
            }
            if(stateVar === "alertasCategoriasTerrestres" && returnVal) {
              let alertasCategoriasTemp = [];
              returnVal.map((i, index) => alertasCategoriasTemp.push({value:i.id_alerta_categoria, label:i.nombre, data:i}));
              //console.log(returnVal);           
              setAlertasCategoriasTerrestres(alertasCategoriasTemp); 
              crud("get", "", "", "terrestresAlertas/atendidas/" + currentUser[0].usuario.id, "alertasAtendiadasTerrestres");
              crud("get", "", "", "terrestresAlertas/noAtendidas/" + currentUser[0].usuario.id, "alertasNoAtendiadasTerrestres");            
            }
            if(stateVar === "alertasAtendiadasNavierasPrioritarias" && returnVal) {
              let alertasAtendiadasNavierasPrioritariasTemp = {};
              for(let cuenta of returnVal){               
                if( !alertasAtendiadasNavierasPrioritariasTemp[cuenta.id_alerta_categoria] ){
                  alertasAtendiadasNavierasPrioritariasTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasAtendiadasNavierasPrioritariasTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasAtendidasPrioritarias(alertasAtendiadasNavierasPrioritariasTemp);             
            }
            if(stateVar === "alertasNoAtendiadasNavierasPrioritarias" && returnVal) {             
              let alertasNoAtendiadasNavierasPrioritariasTemp = {};
              for(let cuenta of returnVal){                
                if( !alertasNoAtendiadasNavierasPrioritariasTemp[cuenta.id_alerta_categoria] ){
                  alertasNoAtendiadasNavierasPrioritariasTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasNoAtendiadasNavierasPrioritariasTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasNoAtendidasPrioritarias(alertasNoAtendiadasNavierasPrioritariasTemp);                  
            }
            if(stateVar === "alertasAtendiadasNavieras" && returnVal) {
              let alertasAtendiadasNavierasTemp = {};
              for(let cuenta of returnVal){               
                if( !alertasAtendiadasNavierasTemp[cuenta.id_alerta_categoria] ){
                  alertasAtendiadasNavierasTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasAtendiadasNavierasTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasAtendidas(alertasAtendiadasNavierasTemp);             
            }
            if(stateVar === "alertasNoAtendiadasNavieras" && returnVal) {             
              let alertasNoAtendiadasNavierasTemp = {};
              for(let cuenta of returnVal){                
                if( !alertasNoAtendiadasNavierasTemp[cuenta.id_alerta_categoria] ){
                  alertasNoAtendiadasNavierasTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasNoAtendiadasNavierasTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasNoAtendidas(alertasNoAtendiadasNavierasTemp);                  
            }
            if(stateVar === "alertasAtendiadasTerrestresPrioritarias" && returnVal) {
              let alertasAtendiadasTerrestresPrioritariasTemp = {};
              for(let cuenta of returnVal){               
                if( !alertasAtendiadasTerrestresPrioritariasTemp[cuenta.id_alerta_categoria] ){
                  alertasAtendiadasTerrestresPrioritariasTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasAtendiadasTerrestresPrioritariasTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasAtendidasTerrestresPrioritarias(alertasAtendiadasTerrestresPrioritariasTemp);
            }
            if(stateVar === "alertasNoAtendiadasTerrestresPrioritarias" && returnVal) {
              let alertasNoAtendiadasTerrestresPrioritariasTemp = {};
              for(let cuenta of returnVal){               
                if( !alertasNoAtendiadasTerrestresPrioritariasTemp[cuenta.id_alerta_categoria] ){
                  alertasNoAtendiadasTerrestresPrioritariasTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasNoAtendiadasTerrestresPrioritariasTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasNoAtendidasTerrestresPrioritarias(alertasNoAtendiadasTerrestresPrioritariasTemp);
            }
            if(stateVar === "alertasAtendiadasTerrestres" && returnVal) {
              let alertasAtendiadasTerrestresTemp = {};
              for(let cuenta of returnVal){               
                if( !alertasAtendiadasTerrestresTemp[cuenta.id_alerta_categoria] ){
                  alertasAtendiadasTerrestresTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasAtendiadasTerrestresTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasAtendidasTerrestres(alertasAtendiadasTerrestresTemp);
            }
            if(stateVar === "alertasNoAtendiadasTerrestres" && returnVal) {
              let alertasNoAtendiadasTerrestresTemp = {};
              for(let cuenta of returnVal){               
                if( !alertasNoAtendiadasTerrestresTemp[cuenta.id_alerta_categoria] ){
                  alertasNoAtendiadasTerrestresTemp[cuenta.id_alerta_categoria] = {};
                }
                alertasNoAtendiadasTerrestresTemp[cuenta.id_alerta_categoria] = cuenta;
              }             
              //console.log(returnVal);
              setConteoAlertasNoAtendidasTerrestres(alertasNoAtendiadasTerrestresTemp);
            }
             break;            
            default:
                break;
        }
    }).catch(err => { console.log(err); });
  }  

  return (   
    <> 
      {<AlertasMensajeria 
        topics={topics}
        refrescar={() => {
          //crud("get", "", "", "alertasCategorias/navierasusuario/" + currentUser[0].usuario.id, "alertasCategoriasNavieras");    
          crud("get", "", "", "alertasCategorias/navieras/" + currentUser[0].usuario.id, "alertasCategoriasNavieras");    
          crud("get", "", "", "alertasCategorias/navierasPrioritarias/" + currentUser[0].usuario.id, "alertasCategoriasNavierasPrioritarias");                      
        }} 
        refrescarTerrestres={() => {
          //crud("get", "", "", "alertasCategorias/terrestresusuario/" + currentUser[0].usuario.id, "alertasCategoriasTerrestres");    
          crud("get", "", "", "alertasCategorias/terrestres/" + currentUser[0].usuario.id, "alertasCategoriasTerrestres"); 
          crud("get", "", "", "alertasCategorias/terrestresPrioritarias/" + currentUser[0].usuario.id, "alertasCategoriasTerrestresPrioritarias");                           
        }}  
      />}
      <div className="row mt-3 ml-3" >        
        <div className="col-6 border border-primary shadow-sm p-3 mb-3 bg-white rounded">
          {alertasCategoriasNavierasPrioritarias.length > 0 ? (            
          <div>
            <h3 className="ml-6">Alertas Prioritarias Navieras</h3>            
            {/*console.log(alertasCategoriasNavieras)*/}
            <div className="row mt-3 ml-3">          
            {alertasCategoriasNavierasPrioritarias.map((acn) =>           
            <div className="col-4">
              <i className={acn.data.logo} style={{"font-size": "24px"}}></i><span style={{"font-size": "13px"}} key={acn}>{ acn.label }</span>
              <ModalLayout 
                 tamanio={'90%'}
                 title={acn.label + " Alertas Atendidas"}
                 name= {  
                          <Alert style={{"font-size": "14px"}} variant="outlined" severity="success" className= "alert alert-primary">
                            Atendidas: { conteoAlertasAtendidasPrioritarias[acn.value] ? conteoAlertasAtendidasPrioritarias[acn.value].count : 0 } 
                          </Alert>
                        }    
                 formulario={<ListarAlertasPorCategorias 
                              idAlertaCategoria={acn.value}
                              atendida={true} 
                              plataformas={"navieras"}
                            />}           
                 hiddenModal={""}
                 Fclose={() => {}}
              />
              <ModalLayout 
                tamanio={'90%'}
                title={acn.label + " Alertas No Atendidas"}
                name= { 
                        <Alert style={{"font-size": "14px"}} variant="outlined" severity="error" className= "alert alert-secundary">
                          No Atendidas: { conteoAlertasNoAtendidasPrioritarias[acn.value] ? conteoAlertasNoAtendidasPrioritarias[acn.value].count : 0 }
                        </Alert>
                 }
                formulario={<ListarAlertasPorCategorias 
                            idAlertaCategoria={acn.value}
                            atendida={false} 
                            plataformas={"navieras"}     
                            refrescar={() => {                              
                              crud("get", "", "", "alertasCategorias/navierasPrioritarias/" + currentUser[0].usuario.id, "alertasCategoriasNavierasPrioritarias");                          
                            }}                      
                />}           
                hiddenModal={""}
                Fclose={() => {}}
              />                  
            </div>                            
            )}  
          </div> 
          </div>
          ) : (
          <div></div>
          )}          
        </div> 
        <div className="col-6 border border-primary shadow-sm p-3 mb-3 bg-white rounded">                     
          {alertasCategoriasTerrestresPrioritarias.length > 0 ? (            
          <div>
            <h3 className="ml-6">Alertas Prioritarias Terrestres</h3>
            <div className="row mt-3 ml-3">
            {alertasCategoriasTerrestresPrioritarias.map((act) =>                    
            <div className="col-4">
              <i className={act.data.logo} style={{"font-size": "24px"}}></i><span style={{"font-size": "13px"}} key={act}>    { act.label } </span>
              <ModalLayout 
                 tamanio={'90%'}
                 title={act.label + " Alertas Atendidas"}
                 name= {  
                          <Alert style={{"font-size": "14px"}} variant="outlined" severity="success" className= "alert alert-primary">
                            Atendidas: { conteoAlertasAtendidasTerrestresPrioritarias[act.value] ? conteoAlertasAtendidasTerrestresPrioritarias[act.value].count : 0 } 
                          </Alert>
                        }    
                 formulario={<ListarAlertasPorCategorias 
                              idAlertaCategoria={act.value}
                              atendida={true} 
                              plataformas={"terrestres"}
                            />}           
                 hiddenModal={""}
                 Fclose={() => {}}
              />
              <ModalLayout 
                tamanio={'90%'}
                title={act.label + " Alertas No Atendidas"}
                name= { 
                        <Alert style={{"font-size": "14px"}} variant="outlined" severity="error" className= "alert alert-secundary">
                          No Atendidas: { conteoAlertasNoAtendidasTerrestresPrioritarias[act.value] ? conteoAlertasNoAtendidasTerrestresPrioritarias[act.value].count : 0 }
                        </Alert>
                 }
                formulario={<ListarAlertasPorCategorias 
                            idAlertaCategoria={act.value}
                            atendida={false} 
                            plataformas={"terrestres"}
                            refrescar={() => {
                              crud("get", "", "", "alertasCategorias/terrestresPrioritarias/" + currentUser[0].usuario.id, "alertasCategoriasTerrestresPrioritarias");                    
                            }}                           
                />}           
                hiddenModal={""}
                Fclose={() => {}}
              />               
            </div>                            
            )}  
          </div> 
          </div>
          ) : (
          <div></div>
          )}           
        </div>      
      </div> 
      <div className="row mt-3 ml-3" >        
        <div className="col-6 border border-primary shadow-sm p-3 mb-3 bg-white rounded">
          {alertasCategoriasNavieras.length > 0 ? (            
          <div>
            <h3 className="ml-6">Alertas Navieras</h3>            
            {/*console.log(alertasCategoriasNavieras)*/}
            <div className="row mt-3 ml-3">          
            {alertasCategoriasNavieras.map((acn) =>           
            <div className="col-4">
              <i className={acn.data.logo} style={{"font-size": "24px"}}></i><span style={{"font-size": "13px"}} key={acn}>{ acn.label }</span>
              <ModalLayout 
                 tamanio={'90%'}
                 title={acn.label + " Alertas Atendidas"}
                 name= {  
                          <Alert style={{"font-size": "14px"}} variant="outlined" severity="success" className= "alert alert-primary">
                            Atendidas: { conteoAlertasAtendidas[acn.value] ? conteoAlertasAtendidas[acn.value].count : 0 } 
                          </Alert>
                        }    
                 formulario={<ListarAlertasPorCategorias 
                              idAlertaCategoria={acn.value}
                              atendida={true} 
                              plataformas={"navieras"}
                            />}           
                 hiddenModal={""}
                 Fclose={() => {}}
              />
              <ModalLayout 
                tamanio={'90%'}
                title={acn.label + " Alertas No Atendidas"}
                name= { 
                        <Alert style={{"font-size": "14px"}} variant="outlined" severity="error" className= "alert alert-secundary">
                          No Atendidas: { conteoAlertasNoAtendidas[acn.value] ? conteoAlertasNoAtendidas[acn.value].count : 0 }
                        </Alert>
                 }
                formulario={<ListarAlertasPorCategorias 
                            idAlertaCategoria={acn.value}
                            atendida={false} 
                            plataformas={"navieras"}     
                            refrescar={() => {
                              //crud("get", "", "", "alertasCategorias/navierasusuario/" + currentUser[0].usuario.id, "alertasCategoriasNavieras");   
                              crud("get", "", "", "alertasCategorias/navieras/" + currentUser[0].usuario.id, "alertasCategoriasNavieras");                           
                            }}                      
                />}           
                hiddenModal={""}
                Fclose={() => {}}
              />                  
            </div>                            
            )}  
          </div> 
          </div>
          ) : (
          <div></div>
          )}          
        </div> 
        <div className="col-6 border border-primary shadow-sm p-3 mb-3 bg-white rounded">                     
          {alertasCategoriasTerrestres.length > 0 ? (            
          <div>
            <h3 className="ml-6">Alertas Terrestres</h3>
            <div className="row mt-3 ml-3">
            {alertasCategoriasTerrestres.map((act) =>                    
            <div className="col-4">
              <i className={act.data.logo} style={{"font-size": "24px"}}></i><span style={{"font-size": "13px"}} key={act}>    { act.label } </span>
              <ModalLayout 
                 tamanio={'90%'}
                 title={act.label + " Alertas Atendidas"}
                 name= {  
                          <Alert style={{"font-size": "14px"}} variant="outlined" severity="success" className= "alert alert-primary">
                            Atendidas: { conteoAlertasAtendidasTerrestres[act.value] ? conteoAlertasAtendidasTerrestres[act.value].count : 0 } 
                          </Alert>
                        }    
                 formulario={<ListarAlertasPorCategorias 
                              idAlertaCategoria={act.value}
                              atendida={true} 
                              plataformas={"terrestres"}
                            />}           
                 hiddenModal={""}
                 Fclose={() => {}}
              />
              <ModalLayout 
                tamanio={'90%'}
                title={act.label + " Alertas No Atendidas"}
                name= { 
                        <Alert style={{"font-size": "14px"}} variant="outlined" severity="error" className= "alert alert-secundary">
                          No Atendidas: { conteoAlertasNoAtendidasTerrestres[act.value] ? conteoAlertasNoAtendidasTerrestres[act.value].count : 0 }
                        </Alert>
                 }
                formulario={<ListarAlertasPorCategorias 
                            idAlertaCategoria={act.value}
                            atendida={false} 
                            plataformas={"terrestres"}
                            refrescar={() => {
                              //crud("get", "", "", "alertasCategorias/terrestresusuario/" + currentUser[0].usuario.id, "alertasCategoriasTerrestres"); 
                              crud("get", "", "", "alertasCategorias/terrestres/" + currentUser[0].usuario.id, "alertasCategoriasTerrestres");                             
                            }}                           
                />}           
                hiddenModal={""}
                Fclose={() => {}}
              />               
            </div>                            
            )}  
          </div> 
          </div>
          ) : (
          <div></div>
          )}           
        </div>      
      </div> 
      <br/>      
    </>
  );  
}

export default AlertasUnidades;
